import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { getUserId } from '@/utils'
import { addAccessLog } from '@/api/index'

Vue.use(VueRouter)

// --- 解决重复点击跳转界面报错 ---- start
// 重写push方法
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

// 重写replace方法
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}
// --- 解决重复点击跳转界面报错 ---- end

const routes = [
  {
    path: '/',
    redirect: '/home/secondColumn'
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/HomeView.vue'),
    redirect: '/home/secondColumn',
    children: [
      {
        path: 'secondColumn',
        component: () => import('@/views/SecondColumn.vue'),
        meta: {
          title: '路通影视 - 深圳市路通网络技术有限公司',
          accessCode: 'qgsp_home_page_column'
        }
      },
      {
        path: 'nettextColumn',
        component: () => import('@/views/NetTextColumn.vue'),
        meta: {
          title: '路通影视 - 深圳市路通网络技术有限公司',
          accessCode: 'qgsp_network_text_column'
        }
      },
      {
        path: 'shortDrama',
        component: () => import('@/views/ShortDramaColumn.vue'),
        meta: {
          title: '路通影视 - 深圳市路通网络技术有限公司',
          accessCode: 'qgsp_playlet_column'
        }
      },
      {
        path: 'search',
        component: () => import('@/views/Search.vue'),
        meta: {
          title: '搜索 - 路通影视 - 深圳市路通网络技术有限公司',
          accessCode: 'qgsp_search_column'
        }
      }
    ]
  },
  {
    path: '/contentpkgPlayer',
    component: () => import('@/views/ContentpkgPlayer.vue'),
    meta: {
      title: '路通影视 - 深圳市路通网络技术有限公司',
      accessCode: 'qgsp_contentpkg_player_column'
    }
  },
  {
    path: '/contentPlayer',
    component: () => import('@/views/ContentPlayer.vue'),
    meta: {
      title: '路通影视 - 深圳市路通网络技术有限公司',
      accessCode: 'qgsp_content_player_column'
    }
  },
  {
    path: '/protocol',
    component: () => import('@/views/Protocol.vue'),
    meta: {
      title: '路通影视 - 深圳市路通网络技术有限公司'
    }
  },
  {
    path: '/personal',
    component: () => import('@/components/layout-personal.vue'),
    redirect: '/edit',
    children: [
      {
        path: '/edit', // 这里，加'/'，访问路由就是/history,不加就是/personal/history
        name: 'edit',
        component: () => import('@/views/personal/edit.vue'),
        meta: {
          title: '修改资料 - 路通影视 - 深圳市路通网络技术有限公司',
          needLogin: true,
          accessCode: 'qgsp_personal_edit_column'
        }
      },
      {
        path: '/history', // 这里，加'/'，访问路由就是/history,不加就是/personal/history
        name: 'history',
        component: () => import('@/views/personal/history.vue'),
        meta: {
          title: '播放历史 - 路通影视 - 深圳市路通网络技术有限公司',
          accessCode: 'qgsp_history_column',
          needLogin: true
        }
      },
      {
        path: '/like',
        name: 'like',
        component: () => import('@/views/personal/like.vue'),
        meta: {
          title: '收藏 - 路通影视 - 深圳市路通网络技术有限公司',
          accessCode: 'qgsp_collect_column',
          needLogin: true
        }
      },
      {
        path: '/setting',
        name: 'setting',
        component: () => import('@/views/personal/setting.vue'),
        meta: {
          title: '账号设置 - 路通影视 - 深圳市路通网络技术有限公司',
          needLogin: true,
          accessCode: 'qgsp_personal_setting_column'
        }
      }
    ]
  }
]

const router = new VueRouter({
  base: '/', // 添加 base 属性
  // base: '/qgsp-res/lutonghd/', // 添加 base 属性 测试环境的
  routes
})
router.beforeEach((to, from, next) => {
  if (to.meta.needLogin && !getUserId()) {
    next('/home/secondColumn')
    return
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // 添加访问日志
  let accessCode = to.meta && to.meta.accessCode
  let sourceCode = from.meta && from.meta.accessCode
  if (to.query.accessCode) accessCode = to.query.accessCode
  if (to.query.sourceCode) sourceCode = to.query.sourceCode
  else if (from.query.accessCode) {
    sourceCode = from.query.accessCode
  }
  if (accessCode) {
    addAccessLog({
      accessCode,
      sourceCode: sourceCode || 'portal',
      jsonData: JSON.stringify(to.query)
    })
  }

  next()
  // 自动登录进页面的，需要获取数据
  if (!store.state.user.hasGetInfo) {
    store.dispatch('setUserInfo')
  }
})
router.afterEach(() => {
  document.body.scrollTop = 0
})
export default router
